import React from 'react';
import { Theme, useTheme, Colorway as Against } from '@uds/theme-utils';

import { RecursiveShortcodeProps } from './Shortcode';

const getColor = (theme: Theme, against: Against | undefined) => {
  switch (against) {
    case Against.LIGHT:
      return theme.palette.primary;
    case Against.NEUTRAL:
      return theme.palette.primary;
    case Against.DARK:
      return theme.palette.tertiary;
    default:
      return 'inherit';
  }
};
const Alt = ({ RecursiveShortcode, elements, against, ...rest }: RecursiveShortcodeProps) => {
  const { theme } = useTheme();
  return (
    <span
      style={{
        color: getColor(theme, against),
      }}
    >
      {RecursiveShortcode ? <RecursiveShortcode elements={elements} against={against} {...rest} /> : null}
    </span>
  );
};

Alt.displayName = 'Alt';

export default Alt;
